<template>
    <div :style="{'height':clientHeight-90+'px'}">
        <div >
            <div class="m-portlet m-b-10">
                <div class="m-portlet__body">
                    <el-form>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="日期">
                                    <el-date-picker
                                            v-model="filter.date"
                                            type="month"
                                            :clearable="false"
                                            value-format="yyyy-MM-dd"
                                            placeholder="选择日期"
                                            @change="handleShow()">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="展示方式">
                                    <el-select v-model="filter.show_type" placeholder="请选择展示方式"
                                               @change="handleShow()" style="width: 160px">
                                        <el-option
                                                v-for="item in show_types"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="筛选">
                                    <el-select v-model="filter.specialChoose"
                                               multiple
                                               clearable
                                               placeholder="请选择"
                                               @change="handleShow()" style="width: 160px">
                                        <el-option
                                                v-for="item in specialTypes"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>


            <div class="m-portlet m-b-10" :style="{'height':(clientHeight-230)+'px'}" v-loading="loading">
                <div class="m-portlet__body">
                    <el-table :data="tableData"
                              :span-method="objectSpanMethod"
                              :row-class-name="tableRowClassName"
                              border
                              :height="clientHeight-380"
                              style="width: 100%">
                        <el-table-column label="校区" prop="section_name" min-width="3%">
                        </el-table-column>
                        <el-table-column label="类型" prop="type_name" min-width="3%">
                        </el-table-column>
                        <el-table-column label="数量" prop="person_number" min-width="3%">
                        </el-table-column>
                        <el-table-column v-for="(item, index) in tableData[0].dates" min-width="3%" :key="index">
                            <template slot="header" slot-scope="scope">
                                {{item.date}}
                            </template>
                            <template slot-scope="scope">{{scope.row.dates[index].number}}</template>
                        </el-table-column>
                    </el-table>
                    <el-table :data="sum_tableData"
                              :span-method="objectSpanMethod"
                              border
                              :show-header="loading"
                              height="130"
                              style="width: 100%">
                        <el-table-column  prop="section_name" min-width="3%" >
                        </el-table-column>
                        <el-table-column  prop="type_name" min-width="3%" >
                        </el-table-column>
                        <el-table-column  prop="person_number" min-width="3%" >
                        </el-table-column>
                        <el-table-column v-for="(item, index) in sum_tableData[0].dates" min-width="3%" :key="index">
                            <template slot="header" slot-scope="scope">
                                {{item}}
                            </template>
                            <template slot-scope="scope">{{scope.row.dates[index]}}</template>
                        </el-table-column>
                    </el-table>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Invoice-list',
        data() {
            return {
                path: "/anlyDashboard/dailyStudent",
                loading: false,
                search_loading: true,
                filter:{
                    date:this.$moment().format('YYYY-MM-DD'),
                    show_type:1,
                    specialChoose:[],
                },
                show_types:[
                    {
                        id:1,
                        name:'学科'
                    },
                    {
                        id:2,
                        name:'年级'
                    }
                ],
                specialTypes:[
                    {
                        value: '1',
                        label: '正常'
                    },
                    {
                        value: '2',
                        label: '试听'
                    },
                    {
                        value: '3',
                        label: '购物车'
                    }
                ],
                tableData: [{
                    section_name:'',
                    type_name:'',
                    person_number:'',
                    dates:[{
                        date:'',
                        number:''
                    }]
                }],
                sum_tableData:[{
                    section_name:'',
                    type_name:'',
                    person_number:'',
                    dates:[]
                }]
            }
        },
        created() {
            this.handleCreate();
            this.handleShow();
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate() {
                //建立webSocket链接
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleData(event, data) {
                switch (event) {
                    case 'init':
                        this.payment_types = data.payment_types;
                        this.sections = data.sections;
                        break;
                    case 'list':
                        this.tableData=data.datas;
                        this.sum_tableData=data.sum_datas
                        this.loading=false;
                        break;
                }
            },
            handleShow(){
                this.loading=true;
                this.$wApi.send(this.path, 'list',{
                    'date':this.filter.date,
                    'show_type':this.filter.show_type,
                    'specialChoose':this.filter.specialChoose,
                });
            },
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0) {
                    return {
                        rowspan: row.sectionRowspan,
                        colspan: row.sectionColspan
                    };

                }
                if (columnIndex === 1) {
                    return {
                        rowspan: row.typeRowspan,
                        colspan: row.typeColspan
                    };
                }

            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];

                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总价';
                        return;
                    }
                    const values = data.map(item => item.dates[index-3]);
                    sums[index] = values.reduce((prev, curr) => {
                        if(curr){
                            const value = Number(curr.number);
                            if (!isNaN(value)) {
                                return prev + curr.number;
                            } else {
                                return prev;
                            }
                        }
                    }, 0);
                });

                return sums;
            },
            tableRowClassName({row, rowIndex}) {
                if (row.type_name === '合计' ) {
                    return 'warning-row';
                }
                return '';
            }
        }
    }
</script>

<style>
    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }
</style>
